<template>
  <div>
    <v-card class="mx-auto rounded-0" flat>
      <v-container class="full-width pa-4">
        <v-row justify="center">
          <v-col cols="10">
            <v-alert colored-border dense border="left" color="blue" class="bg-info no-border mb-2">
              <h2 class="orange--text text--darken-3">Perhatian !!!</h2>
              <p class="mt-2 mb-1" style="font-size: 18px">
                Penilaian dapat dilakukan mulai
                <strong>
                  tanggal 1 Desember 2023 sampai batas waktu yang diinformasikan oleh Direktorat Guru dan Tenaga
                  Kependidikan kepada BGP/BBGP
                </strong>
              </p>
              <p class="mb-2" style="font-size: 18px">
                Bapak/Ibu dapat mengetahui lebih lanjut terkait evaluasi kinerja
                {{ isInstrumenFsp ? 'FSP' : 'KFSP' }} dengan mengakses tautan
                <a href="https://s.id/EvkinFSP" class="text-decoration-underline" target="_blank">
                  https://s.id/EvkinFSP
                </a>
              </p>
            </v-alert>
          </v-col>
          <v-col cols="12" lg="6">
            <div class="mb-2">
              <h2>Evaluasi Kinerja</h2>
            </div>
            <div class="mb-2">
              <h4>Petunjuk Pengisian Instrumen</h4>
            </div>
            <ol>
              <li v-for="(item, id) in petunjuk" :key="id">{{ item }}</li>
            </ol>
            <p class="black--text mt-3">
              Penilaian yang diberikan bersifat rahasia. Seluruh hasil penilaian akan diolah secara tertutup oleh tim
              pengolah nilai. Silakan memberikan penilaian secara jujur, jelas, dan objektif.
            </p>
            <p class="black--text mt-3"> Pilih tombol <strong>“Mulai Nilai”</strong> untuk melakukan penilaian. </p>
            <p class="black--text font-weight-medium">
              Hormat Kami,
              <br />
              Tim Program Sekolah Penggerak
            </p>
          </v-col>
          <v-col cols="12" lg="4">
            <v-img src="https://penggerak-cdn.siap.id/s3/gurupenggerak/illust-lapor-seleksi-diklatpgp.jpg"></v-img>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-footer absolute>
      <v-col class="text-center" cols="12">
        <v-btn depressed class="text-capitalize" color="primary" @click="$emit('next')">
          {{ isEdit ? 'Mulai Nilai' : 'Lihat Nilai' }}
        </v-btn>
      </v-col>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: 'KinerjaPembukaan',
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    sasaran: {
      type: String,
      default: '',
    },
  },
  computed: {
    petunjuk() {
      if (['kfsp-satker-a3', 'kfsp-satker-a12'].includes(this.sasaran)) {
        return this.petunjukSatkerKfsp;
      }

      if (['kfsp-fsp-a3', 'kfsp-fsp-a12'].includes(this.sasaran)) {
        return this.petunjukFspKfsp;
      }

      if (['fsp-kfsp-a3', 'fsp-kfsp-a12'].includes(this.sasaran)) {
        return this.petunjukKfspFsp;
      }

      return this.petunjukKsFsp;
    },

    isInstrumenFsp() {
      return ['fsp-kfsp-a3', 'fsp-kfsp-a12', 'fsp-ks-a3', 'fsp-ks-a12'].includes(this.sasaran);
    },

    petunjukSatkerKfsp() {
      return [
        'Bacalah instrumen dengan teliti',
        'Instrumen ini adalah penilaian kinerja dari KFSP di bawah naungan BBGP/BGP.',
        'Pilihlah salah satu jawaban yang sesuai dengan kondisi KFSP tersebut.',
      ];
    },

    petunjukKfspFsp() {
      return [
        'Bacalah instrumen dengan teliti',
        'Instrumen ini adalah penilaian kinerja dari FSP yang Anda dampingi.',
        'Instrumen terdiri dari 5 komponen yaitu perencanaan, pendampingan dan tindak lanjut, kecakapan berkomunikasi, komitmen, laporan perkembangan satuan pendidikan.',
        'Pilihlah salah satu jawaban yang sesuai dengan kondisi FSP yang Anda dampingi.',
      ];
    },

    petunjukFspKfsp() {
      return [
        'Bacalah instrumen dengan teliti',
        'Instrumen ini adalah penilaian kinerja dari KFSP yang mendampingi Anda.',
        'Pilihlah salah satu jawaban yang sesuai dengan kondisi KFSP Anda.',
      ];
    },

    petunjukKsFsp() {
      return [
        'Bacalah instrumen dengan teliti',
        'Instrumen ini adalah penilaian kinerja dari FSP yang mendampingi sekolah Anda.',
        'Instrumen terdiri dari 4 komponen yaitu kecakapan fasilitasi, pendampingan dan tindak lanjut, komunikasi, sikap.',
        'Pilihlah salah satu jawaban yang sesuai dengan kondisi FSP yang mendampingi sekolah Anda.',
      ];
    },
  },
};
</script>

<style scoped></style>
